/**
 * Profile Routes
 *
 * URL Pattern: /profile
 */

export default [
    {
        path: '/profile',
        component: () => import('@/pages/profile/index.vue'),
        name: 'app.profile',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
        children: [
            {
                path: 'update',
                component: () => import('@/pages/profile/update.vue'),
                name: 'app.profile.update',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: '*',
                },
            },
        ],
    },
];
